import { render, staticRenderFns } from "./VersionHistory.vue?vue&type=template&id=3976a3f8&scoped=true"
import script from "./VersionHistory.vue?vue&type=script&lang=js"
export * from "./VersionHistory.vue?vue&type=script&lang=js"
import style0 from "./VersionHistory.vue?vue&type=style&index=0&id=3976a3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976a3f8",
  null
  
)

export default component.exports